import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Badge } from '@/components/ui/badge';
import { ScrollArea } from '@/components/ui/scroll-area';
import { Loader2 } from 'lucide-react';
import { getFieldLabel } from '@/lib/fieldLabel';

export function BrowseDataDialog({ open, onOpenChange, browseField, browseData, browseLoading, formatValue }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="glass-card border-border/50 rounded-2xl sm:max-w-md max-h-[70vh] overflow-hidden flex flex-col">
        <DialogHeader>
          <DialogTitle className="font-heading text-base">
            Browse: {browseField ? getFieldLabel(browseField, browseField.name) : ''}
          </DialogTitle>
        </DialogHeader>
        {browseField && (
          <div className="space-y-2 mt-1">
            <div className="flex items-center gap-2 text-[10px] text-muted-foreground">
              <span className="font-mono">{browseField.name}</span>
              <Badge variant="outline" className="text-[8px]">{browseField.data_type}</Badge>
              <Badge className={'text-[8px] ' + (browseField.semantic_type === 'measure' ? 'bg-primary/20 text-primary' : 'bg-emerald-500/20 text-emerald-400')}>{browseField.semantic_type}</Badge>
              <span className="ml-auto">{browseData.length} distinct values</span>
            </div>
            <ScrollArea className="flex-1 max-h-80">
              {browseLoading ? (
                <div className="flex items-center justify-center py-8"><Loader2 className="w-5 h-5 text-primary animate-spin" /></div>
              ) : (
                <div className="rounded-lg border border-border/30 overflow-hidden">
                  <table className="w-full text-[11px]">
                    <thead>
                      <tr className="border-b border-border/30 bg-muted/20">
                        <th className="px-3 py-1.5 text-left text-[9px] text-muted-foreground font-semibold w-10">#</th>
                        <th className="px-3 py-1.5 text-left text-[9px] text-muted-foreground font-semibold">Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      {browseData.map(function(val, i) { return (
                        <tr key={i} className="border-b border-border/10 hover:bg-muted/10">
                          <td className="px-3 py-1 text-muted-foreground/70">{i + 1}</td>
                          <td className="px-3 py-1 font-mono text-foreground">{browseField ? formatValue(val, browseField.name) : String(val)}</td>
                        </tr>
                      ); })}
                      {browseData.length === 0 && !browseLoading && (
                        <tr><td colSpan={2} className="px-3 py-4 text-center text-muted-foreground/70">No data</td></tr>
                      )}
                    </tbody>
                  </table>
                </div>
              )}
            </ScrollArea>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
